import { render, staticRenderFns } from "./ClaimsRemovalRequests.vue?vue&type=template&id=96e11050&scoped=true"
import script from "./ClaimsRemovalRequests.vue?vue&type=script&lang=js"
export * from "./ClaimsRemovalRequests.vue?vue&type=script&lang=js"
import style0 from "./ClaimsRemovalRequests.vue?vue&type=style&index=0&id=96e11050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e11050",
  null
  
)

export default component.exports